import * as React from 'react';

import initBem from 'js/lib/bem';

import { Typography2 } from '@coursera/cds-core';
import { Checkbox, color } from '@coursera/coursera-ui';

import { CMLOrHTML } from 'bundles/cml';
import type { Option as OptionType } from 'bundles/compound-assessments/types/FormParts';

import 'css!./__styles__/Option';

const bem = initBem('Option');

type Props = {
  option: OptionType;
  isSelected: boolean;
  onChange: (event: { target: HTMLInputElement }) => void;
  isDisabled: boolean;
  isReadOnly: boolean;
  isRadio?: boolean;
  promptId: string;
  inputHtmlAttributes?: React.InputHTMLAttributes<HTMLInputElement>;
};

const Option = ({
  onChange,
  option,
  isSelected,
  isDisabled,
  isReadOnly,
  promptId,
  isRadio = false,
  inputHtmlAttributes,
}: Props) => (
  <div className={bem(undefined, { isReadOnly })}>
    <Checkbox
      disabled={isDisabled}
      onChange={onChange}
      checked={isSelected}
      value={option.id}
      isRadio={isRadio}
      readOnly={isReadOnly}
      name={promptId}
      {...(isReadOnly
        ? {
            uncheckedColor: color.secondaryText,
            uncheckedHoverColor: color.secondaryText,
            checkedColor: color.secondaryText,
            checkedHoverColor: color.secondaryText,
          }
        : {})}
      inputHtmlAttributes={{
        ...inputHtmlAttributes,
        ...((isDisabled || isReadOnly) && { tabindex: -1 }),
      }}
    >
      <Typography2 variant="bodyPrimary" component="div">
        <CMLOrHTML value={option.display} className={bem('input-text')} display="inline-block" />
      </Typography2>
    </Checkbox>
  </div>
);

export default Option;
